<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title Buchungsextras
    .sub-headline Hier können Sie alle Buchungsextras pflegen.

    .rent-object-features-wrapper.margin-top
      .button-flex
        .button-wrapper  
          b-button(type="is-light" icon-left="plus" @click="newBookingExtra()") Neues Buchungsextra anlegen

      .card.margin-top
        .main
          b-table(
            :data="bookingExtras",
            default-sort-direction="desc",
            default-sort="price",
            hoverable
          )
            b-table-column(
              field="name",
              label="Name",
              sortable,
              v-slot="props"
            )
              | {{ props.row.name }}
              br
              b-tag(v-if="props.row.includeCommission" type="is-warning" size="is-small") Provision
              b-tag(v-if="props.row.includeCancelInvoice" type="is-danger" size="is-small") Stornierungsrechnung
            b-table-column(
              field="code",
              label="Code",
              sortable,
              v-slot="props"
            )
              b-tag(type="is-light") {{ props.row.code }}
            b-table-column(
              field="internalDescription",
              label="Interne Beschreibung",
              sortable,
              v-slot="props"
            )
              .is-small {{ props.row.internalDescription }}
            b-table-column(
              field="externalDescription",
              label="Kunden Beschreibung",
              sortable,
              v-slot="props"
            )
              .is-small {{ props.row.externalDescription }}
            b-table-column(
              field="interval",
              label="Intervall",
              sortable,
              v-slot="props"
            )
              | {{ props.row.interval === 'once' ? 'einmalig' : 'täglich' }}
            b-table-column(
              field="price",
              label="Preis",
              sortable,
              numeric,
              v-slot="props"
            )
              | {{ props.row.price/100 | toCurrency }}
            
            b-table-column(
              field="multiplier",
              label="Multiplikator",
              v-slot="props")
              | {{ props.row.multiplier ? props.row.multiplier : "-" }}
            
            b-table-column(
              label="Kondition",
              v-slot="props")
              | {{ getConditionString(props.row) }}
            
            b-table-column(
              label="Objekt-#",
              v-slot="props"
              centered)
              | {{ props.row.rentObjectBookingExtras.length }}x

            b-table-column(v-slot="props" width="120")
              div
                b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                  b-button(icon-right="pencil", type="is-secondary" @click="openModal(props.row)")
                .spacer.sm.inline
                b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250" v-if="props.row.rentObjectBookingExtras.length === 0")
                  b-button(icon-right="close", type="is-danger" @click="deleteBookingExtra(props.row.id)")
                b-tooltip(label='Wird in Objekten verwendet' type='is-danger' position='is-bottom' v-else)
                  b-button(icon-right="close", type="is-danger" disabled)

      b-modal(v-model='isModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
        template(#default='props')
          .form.w512
            .card.margin-top
              .top
                h2.title.is-6(v-if="formData.id") Buchungsextra aktualisieren
                h2.title.is-6(v-else) Neues Buchungsextra
                ValidationObserver(v-slot="{ handleSubmit }", ref="form")
                  ValidationProvider(
                    name="Name",
                    rules="required|min:2",
                    v-slot="{ errors, valid }"
                  )
                    b-field(
                      label="Name",
                      label-position="on-border",
                      :type="{ 'is-danger': errors[0], 'is-success': valid }",
                      :message="errors"
                    )
                      b-input(v-model="formData.name")
                  ValidationProvider(
                    name="Code",
                    rules="required|min:1|max:3",
                    v-slot="{ errors, valid }"
                  )
                    b-field(
                      label="Code",
                      label-position="on-border",
                      :type="{ 'is-danger': errors[0], 'is-success': valid }",
                      :message="errors"
                    )
                      b-input(v-model="formData.code")
                  ValidationProvider(
                    name="Interne Beschreibung",
                    rules="",
                    v-slot="{ errors, valid }"
                  )
                    b-field(
                      label="Interne Beschreibung",
                      label-position="on-border",
                      :type="{ 'is-danger': errors[0], 'is-success': valid }",
                      :message="errors"
                    )
                      b-input(
                        v-model="formData.internalDescription",
                        maxlength="200",
                        type="textarea"
                      )
                  ValidationProvider(
                    name="Kunden Beschreibung",
                    rules="",
                    v-slot="{ errors, valid }"
                  )
                    b-field(
                      label="Kunden Beschreibung",
                      label-position="on-border",
                      :type="{ 'is-danger': errors[0], 'is-success': valid }",
                      :message="errors"
                    )
                      b-input(
                        v-model="formData.externalDescription",
                        maxlength="200",
                        type="textarea"
                      )
                  b-field(grouped)
                    ValidationProvider(
                        name="Preis",
                        :rules="{ required: true, currency: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*\.[0-9]{2}$/gm }",
                        v-slot="{ errors, valid }")
                      b-field(
                        label="Preis",
                        label-position="on-border",
                        :type="{ 'is-danger': errors[0], 'is-success': valid }",
                        :message="errors")
                        b-input(v-model="formData.price")
                    .spacer.sm
                    ValidationProvider(
                      name="Intervall",
                      rules="required",
                      v-slot="{ errors, valid }"
                    )
                      b-field(
                        label="Intervall",
                        label-position="on-border",
                        :type="{ 'is-danger': errors[0], 'is-success': valid }",
                        :message="errors"
                      )
                        b-select(v-model="formData.interval")
                          option(value="once") Einmalig
                          option(value="daily") Täglich
                    .spacer.sm
                    ValidationProvider(
                      name="Einheit",
                      rules="",
                      v-slot="{ errors, valid }"
                    )
                      b-field(
                        label="Multiplikator",
                        label-position="on-border",
                        :type="{ 'is-danger': errors[0], 'is-success': valid }",
                        :message="errors"
                      )
                        b-select(v-model="formData.multiplier")
                          option(:value="null") ---
                          option(value="person") pro Person

                  h2.title.is-6 Spezielle Einstellungen
                  template(v-if="formData.interval === 'once'" )
                    b-field(grouped)
                      b-field(
                        expanded
                        label-position="on-border")
                        b-checkbox(v-model="formData.onSunday") nur für Sonntage
                      .spacer.sm
                      b-field(
                        expanded
                        label-position="on-border")
                        b-checkbox(v-model="formData.onHoliday") nur für Feiertage
                    
                    b-field(grouped)
                      b-field(
                        expanded
                        label-position="on-border")
                        b-checkbox(v-model="formData.onArrival") am Anreisetag
                      .spacer.sm
                      b-field(
                        expanded
                        label-position="on-border")
                        b-checkbox(v-model="formData.onDeparture") am Abreisetag

                    .breaker

                  b-field(grouped)
                    b-field(
                      expanded
                      label-position="on-border")
                      b-checkbox(v-model="formData.includeCommission") Provision
                    b-field(
                      expanded
                      label-position="on-border")
                      b-checkbox(v-model="formData.includeCancelInvoice") Stornierungsrechnung
                  .error(v-if="(formData.onSunday || formData.onHoliday) && (!formData.onArrival && !formData.onDeparture)") Sie müssen den Tag der Kondition auswählen.

                  p.content(v-if="formData.name && formData.price") Das Buchungsextra "{{ formData.name }}" kostet {{ formData.interval === 'once' ? 'einmalig' : '' }} {{ formData.price }}€ {{ formData.multiplier === 'person' ? 'pro Person' : ' ' }}{{ formData.interval === 'daily' ? ' pro Tag' : '' }}.

                    .button-wrapper.margin-top.right
                      b-button(
                        type="is-light",
                        @click="isModalActive = false"
                      ) Abbrechen
                      b-button(
                        v-if="formData.id"
                        type="is-primary",
                        @click="handleSubmit(saveBookingExtra)"
                        :disabled="(formData.onSunday || formData.onHoliday) && (!formData.onArrival && !formData.onDeparture)"
                      ) Aktualisieren
                      b-button(
                        v-else
                        type="is-primary",
                        @click="handleSubmit(saveBookingExtra)"
                        :disabled="(formData.onSunday || formData.onHoliday) && (!formData.onArrival && !formData.onDeparture)"
                      ) Speichern
</template>

<script>
export default {
  data() {
    return {
      isModalActive: false,
      formData: {
        name: "",
        code: "",
        internalDescription: "",
        externalDescription: "",
        interval: null,
        price: null,
        onSunday: false,
        onHoliday: false,
        onArrival: false,
        onDeparture: false,
        includeCommission: false,
        includeCancelInvoice: false,
        multiplier: null,
      },
    };
  },
  computed: {
    bookingExtras() {
      return this.$store.state.bookingExtras.all;
    },
  },
  methods: {
    openModal(p) {
      this.formData = {...this.formData, ...p};
      this.formData.price = (this.formData.price/100).toFixed(2);
      this.isModalActive = true;
    },
    newBookingExtra() {
      this.formData = {
        name: "",
        code: "",
        internalDescription: "",
        externalDescription: "",
        interval: null,
        price: null,
        onSunday: false,
        onHoliday: false,
        onArrival: false,
        onDeparture: false,
        includeCommission: false,
        includeCancelInvoice: false,
        multiplier: null,
      };
      this.isModalActive = true;
    },
    async saveBookingExtra() {
      const centPrice = parseInt(this.formData.price.replace(",", ".") * 100);
      await this.$store.dispatch("bookingExtras/create", {
        ...this.formData,
        price: centPrice,
      });
      this.formData = {
        name: "",
        code: "",
        internalDescription: "",
        externalDescription: "",
        interval: null,
        price: null,
        onSunday: false,
        onHoliday: false,
        onArrival: false,
        onDeparture: false,
        includeCommission: false,
        multiplier: null,
      }
      this.$refs.form.reset();
      this.isModalActive = false;
    },
    deleteBookingExtra(id) {
      let bookingExtra = this.bookingExtras.find((b) => b.id === id);

      this.$buefy.dialog.confirm({
        title: "Buchungsextra löschen",
        message: `Sind Sie sicher, dass Sie dieses Buchungsextra <b>${bookingExtra.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("bookingExtras/delete", {
              id,
            });
            this.$buefy.toast.open("Buchungsextra gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Buchungsextra konnte nicht gelöscht werden."
            );
          }
        },
      });
    },
    getConditionString(row) {
      let s = "Gilt nur wenn der ";
      if (!row.onSunday && !row.onHoliday && !row.onArrival && !row.onDeparture) return "-"
      if ((!row.onSunday && !row.onHoliday) && (row.onArrival || row.onDeparture)) return "-"
      
      if (row.onArrival && row.onDeparture) {
        s += "Anreise- oder Abreisetag auf "
      } else if (row.onArrival && !row.onDeparture) {
        s += "Anreisetag auf "
      } else if (!row.onArrival && row.onDeparture) {
        s += "Abreisetag auf "
      }

      if (row.onSunday && row.onHoliday) {
        s += "ein Sonntag oder Feiertag fällt."
      } else if (row.onSunday && !row.onHoliday) {
        s += "ein Sonntag fällt."
      } else if (!row.onSunday && row.onHoliday) {
        s += "einen Feiertag fällt."
      }
      return s;
    }
  },
  async mounted() {
    await this.$store.dispatch("bookingExtras/findAll");
  },
};
</script>

<style lang="scss" scoped>
.is-small {
  font-size: 0.8rem;
}
</style>